module.exports = __webpack_public_path__ + "img/data-icon.7ece900c.png";